(function ($, undefined) {
    // This is jQuery plugin to do zip/postal code lookup and populate data to other fields (using provided mapping).
    // Options:
    // - 'country' - Restrict results to a specific country
    // - 'autopopulate' - Flag indicating whether to populate selected address data to provided form fields.
    // - 'fieldsMapping' - Object containing fields mapping { addressComponent: fieldSelector } 
    //    Supported address components: 'CITY', 'STATE_OR_REGION'
    // - 'callback' - Callback function to be fired when look up succeeds
    var defaultOptions = {
        autopopulate: null,
        fieldsMapping: {},
        country: null,
        callback: null
    };

    // Constructor for Address Autocomplete input field
    // The first one is input object for autocomplete
    // and the second one is object of options to set
    function ZipLookup(input, options) {
        this.options = $.extend(true, {}, defaultOptions, options);
        this.input = input;
        this.$input = $(input);
        this.geocoder = new google.maps.Geocoder();
        this._defaults = defaultOptions;
        // call initialize function for the input object
        this.init();
    }

    $.extend(ZipLookup.prototype, {
        init: function () {
            this.$input.change($.proxy(this.doTheLookup, this));
        },

        //for each component list of address components [https://developers.google.com/maps/documentation/geocoding/] must be specified (order matters)
        googleComponentMapping: {
            'CITY': ['locality', 'administrative_area_level_3'],
            'STATE_OR_REGION': ['administrative_area_level_1', 'administrative_area_level_2']
        },

        findComponent: function (place, type) {
            var component = _.find(place.address_components, function (cmp) {
                return _.some(cmp.types, function (t) { return t === type; });
            });
            return typeof component !== 'undefined' ? component : null;
        },

        doTheLookup: function() {
            var zipCode = this.$input.val();
            if (zipCode.length >= 5 && typeof google !== 'undefined') {
                var request = {
                    'address': zipCode
                };
                if (this.options.country) {
                    request.componentRestrictions = { country: this.options.country };
                };

                this.geocoder.geocode(request, $.proxy(function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK && results.length >= 1) {
                        this.populateData(results[0]);
                        // Fire callback function (if provided)
                        if (this.options.callback) {
                            this.options.callback(results[0], this.$input);
                        }
                    }
                }, this));
            }
        },

        populateData: function (data) {
            for (var fieldMappingKey in this.options.fieldsMapping) {
                var $mappedField = $(this.options.fieldsMapping[fieldMappingKey]);

                if ($mappedField.length === 0) {
                    continue;
                }

                var matchingComponent = {
                    shortName: null,
                    longName: null
                };

                switch (fieldMappingKey) {
                    case 'CITY':
                    case 'STATE_OR_REGION':
                        var keys = this.googleComponentMapping[fieldMappingKey];

                        for (var i = 0; i < keys.length; i++) {
                            var component = this.findComponent(data, keys[i]);
                            if (typeof component !== 'undefined' && component !== null) {
                                matchingComponent.shortName = component.short_name;
                                matchingComponent.longName = component.long_name;
                                break;
                            }
                        }
                        break;
                }

                var fieldType = $mappedField.get(0).tagName;
                var fieldvalue;

                switch (fieldType) {
                    case 'SELECT':
                        if (matchingComponent.shortName !== null) {
                            fieldvalue = matchingComponent.shortName;
                        } else {
                            fieldvalue = $mappedField.find('option:first').val();
                        }
                        break;
                    default:
                        fieldvalue = matchingComponent.longName !== null
                            ? matchingComponent.longName
                            : '';
                        break;
                }

                if ($mappedField.val() !== fieldvalue) {
                    $mappedField.val(fieldvalue);
                    $mappedField.trigger('change.jqueryziplookup');
                }
            }
        }
    });

    // Wrapper for the plugin around the constructor.
    // 'options' - all settings that are different from the default (defined at the top).
    // The 'attr' is used to prevent multiple instantiations of the plugin.
    $.fn.ziplookup = function (options) {
        var attr = 'plugin.ziplookup';
        if (typeof options == "string") {
            var instance = $(this).data(attr) || $(this).ziplookup().data(attr),
              prop = instance[options];

            if (typeof prop == "function") {
                prop.apply(instance, Array.prototype.slice.call(arguments, 1));
                return $(this);
            } else {
                if (arguments.length == 2) {
                    prop = arguments[1];
                }
                return prop;
            }
        } else {
            return this.each(function () {
                var instance = $.data(this, attr);
                if (instance) {
                    if (instance.options.country != options.country) {
                        options.callback = options.callback || instance.callback;
                        instance.options = options;
                    }
                } else {
                    instance = new ZipLookup(this, options);
                }
                $.data(this, attr, instance);
            });
        }
    };
}(jQuery));
define("plugins/jquery.ziplookup", ["jquery"], function(){});

